module.exports = __webpack_public_path__ + "img/checkmark.fe491e51.svg";